import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { EmptyState } from "../../components/ui/EmptyState";

/** Empty state for the community activity feed. The full variant (the
 *  /community route) adds an eyebrow and a CTA that points drivers at the
 *  chargers map — reporting status there is what generates feed activity.
 *  The compact variant is the 320px right rail, where the same CTA would be a
 *  no-op on the chargers page it sits beside, so it drops the eyebrow + CTA. */
export function CommunityEmptyState({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  return (
    <EmptyState
      glyph="📡"
      eyebrow={compact ? undefined : t("community.feed_empty_eyebrow")}
      title={t("community.feed_empty")}
      body={t("community.feed_empty_body")}
      action={
        compact ? undefined : (
          <Link to="/chargers" className="btn-volt inline-flex items-center px-4 py-2 text-sm">
            {t("community.feed_empty_cta")}
          </Link>
        )
      }
    />
  );
}
